import {Card} from 'react-bootstrap';
import styled from 'styled-components';


export default styled(Card)`

  background-color: #f7e7ce;
`;
